module.exports = __webpack_public_path__ + "assets/hw.4a7f24d7.svg";